<!-- Backdrop -->
<div class="fixed inset-0 z-80 bg-black/30 backdrop-blur-sm" *ngIf="show" (click)="close.emit()"></div>

<!-- Modal Wrapper -->
<div class="fixed inset-0 z-90 flex px-2 sm:px-4 md:px-6 lg:px-8 py-2 sm:py-4 md:py-6 lg:py-8" [ngClass]="{
    'justify-end items-start pt-8': position === 'right',
    'justify-center items-center': position !== 'right'
  }" *ngIf="show">
  <div class="bg-white w-full rounded-lg shadow-xl overflow-y-auto flex flex-col relative" [ngClass]="[
    dialogSizeClass,
    position === 'right' ? 'h-full mt-0' : 'max-h-[95vh] mt-12'
  ]" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div *ngIf="showHeader" class="border-b border-b-gray-200 sm:px-4 md:px-6 lg:px-6">
      <div class="flex justify-between items-center py-2 sm:py-3 md:py-4">
        <span style="color: #1F2937; font-family: Inter, sans-serif; font-size: 20px;"
        class="font-semibold">
          {{ title }}
        </span>
        <button (click)="close.emit()" aria-label="Close" class="text-xl sm:text-2xl cursor-pointer" style="color: #1F2937;">×</button>
      </div>
    </div>


    <!-- Modal Content -->
    <div class="flex-1 overflow-y-auto pt-4 sm:pt-2 md:pt-2 lg:pt-2 xl:pt-3 2xl:pt-3">
      <ng-content></ng-content>
    </div>
    <!-- Actions slot -->
    <div class="flex justify-end gap-2 pb-1 pt-2 bg-white">
      <ng-content select="[dialog-actions]"></ng-content>
    </div>
  </div>
</div>